export default {
  defaultObject () {
    return {
      name: '',
      email: '',
      contactName: '',
      userIds: [],
      unitIds: [],
      linkedReseller: '',
      phoneNumber: '',
      units: []
    }
  }
}
